export const locales = ["en", "sv", "de"] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = "en";
